/** Components */
import {
    replaceRequestId,
    RequestIdWithWarning,
    Causales,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';

import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';

const commonColumns = [
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    {
        Header: 'Identificación',
        accessor: 'persona.numero_identificacion',
    },
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Ciudad',
        accessor: 'concesionario_ciudad.label',
    },
    {
        Header: 'Concesionario',
        accessor: 'concesionario.label',
    },
    {
        Header: 'Marca',
        accessor: 'vehiculossolicitud.marca.label',
    },
    {
        Header: 'Linea',
        accessor: 'vehiculossolicitud.linea.label',
    },
];

export const requestsListStatus = [
    {
        id: 'tableAliado',
        label: 'APROBADAS',
        status: 50,
        responsable: null,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(0, 0, RequestIdWithWarning());
            cols.splice(1, 0, {
                Header: 'Fecha Aprobación',
                accessor: 'gestionsolicitud.fecha_mesa_aprobacion',
            });

            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits

    },
    {
        id: 'procesadas_mesa_de_ayuda',
        label: 'DESEMBOLSADAS',
        status: false,
        statusExclude:50,
        responsable: false,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols.splice(0, 0,RequestIdWithWarning());
                cols.splice(1, 0, {
                    Header: 'Fecha Creación ',
                    accessor: 'gestionsolicitud.fecha_creacion',
                });
                cols.splice(7, 0, {
                    Header: 'Tel Cliente',
                    accessor: 'persona_info_contacto.celular',
                });

                cols.splice(8, 0, OfficeRequest);
                cols.splice(9, 0, ExecutiveWithTooltip);
                cols.splice(10, 0, StatusWithTooltip);
                cols.splice(11, 0, Causales());

                return cols;
            })()
        ),
        registrationLimit: 5, // limit for registration in list credits
    },
];
